import { render, staticRenderFns } from "./DoctorAddIcon.vue?vue&type=template&id=21a7f752"
import script from "./DoctorAddIcon.vue?vue&type=script&lang=js"
export * from "./DoctorAddIcon.vue?vue&type=script&lang=js"
import style0 from "./DoctorAddIcon.vue?vue&type=style&index=0&id=21a7f752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports